// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.hidden_header[data-v-09182d8f] {\n    display: none;\n}\nmy-header-class[data-v-09182d8f] {\n    color: #af5934;\n    font-size: 15px;\n    font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
